import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'
import { Switch } from 'react-router-dom'

const NotificationsListLazy = lazy(
	() => import('Pages/admin/serviceNotifications/components/NotificationsList')
)
const NotificationsItemLazy = lazy(
	() => import('Pages/admin/serviceNotifications/components/NotificationsItem')
)

export const ServiceNotificationsRoutes = () => {
	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.admin_panel.notifications}
				lazyComponent={NotificationsListLazy}
				key={FrontUrls.admin_panel.notifications}
			/>
			<LazyRoute
				path={FrontUrls.admin_panel.notifications_edit}
				lazyComponent={NotificationsItemLazy}
				key={FrontUrls.admin_panel.notifications_edit}
			/>
			<LazyRoute
				path={FrontUrls.admin_panel.notifications_create}
				lazyComponent={NotificationsItemLazy}
				key={FrontUrls.admin_panel.notifications_create}
			/>
		</Switch>
	)
}
